import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  coachmarkleft,
  coachmarkright,
  copy,
  Eye,
  global,
  greenTick,
  imgeight,
  imgfive,
  imgfour,
  imgnine,
  imgone,
  imgseven,
  imgsix,
  imgthree,
  imgtwo,
  live,
  makelivesend,
  referral,
  sendlivedata,
  share_icon,
  Web,
  whiteArrow,
} from "../../../assets/assets";
import AddWebsiteModel from "../../../Modal/AddWebsiteModal";
import DomainAllotmentModal from "../../../Modal/DomainAllotmentModel";
import WebsiteLiveModal from "../../../Modal/WebsiteLiveModal";
import {
  saveWebsiteData,
  showCoachMark,
} from "../../../Redux/Slices/MainSlice";
import httpApiCall from "../../../service/api.service";
import {
  Regex,
  accessTokenLogin,
  getStorageValue,
} from "../../../service/shared.service";
import toastr from "../../elements/toast";
import { url } from "inspector";
import { Modal, Button, Spinner, Dropdown } from "react-bootstrap";
import ReactCrop from "react-image-crop";
import { getDomainSuggestions } from "../../../service/common_function";
import React from "react";
import Logs from "./Logs";
import AddDemoModal from "../../../Modal/AddDemoModal";

const Website = ({ partner_domains }: any) => {
  // const partnerProfileData = getStorageValue("partnerData");
  const eventData = useSelector((state: any) => {
    const profileData = state?.APIData?.partnerProfileData.partner_events;
    return profileData && [profileData].length > 0 ? profileData : null;
  });
  const partnerProfileData = useSelector(
    (state: any) => state?.APIData?.partnerData
  );
  const [show, setShow] = useState({
    modalShare: false,
    value_type: 0,
  });
  const toastrService = new toastr(true);
  const [showModalType, setshowModalType] = useState({
    showDomainsModal: false,
    showWebsiteModal: true,
  });
  const [sppiner, setSppiner] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [sppinerTwo, setSppinerTwo] = useState(false);
  const [update, setUpdate] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [websiteModalShow, setWebsiteModalShow] = useState(false);
  const [domainModalShow, setDomainModalShow] = useState(false);
  const [updateHint, setUpdateHint] = useState(true);
  const [allDomains, setallDomains] = useState([]);
  const [templateId, setTemplateId] = useState(0);
  let [imageIndex, setImageIndex] = useState(1);
  let [flagIndex, setFlagIndex] = useState(0);
  const [hideTooltip, setHideTooltip] = useState(false);
  const [domainType, setDomainType] = useState(1);
  const [partnerDomains, setPartnerDomains] = useState();
  const [showMakeItLiveBtn, setShowMakeItLiveBtn] = useState({
    p2pActiveUrl: "",
    p2pIsActive: 0,
    p2bActiveUrl: "",
    p2bIsActive: 0,
    activeTemplate: 0,
    p2pdomain: 0,
    p2bdomain: 0,
  });

  const imageWebsite = [
    {
      src: imgone,
      templateId: 1,
      srcTwo: imgfive,
    },
    {
      src: imgtwo,
      templateId: 2,
      srcTwo: imgnine,
    },
    {
      src: imgthree,
      templateId: 3,
      srcTwo: imgeight,
    },
  ];
  const suggestionScreenArr: any = [
    {
      id: 1,
      text: "This is your default website layout",
      btn_text: "Next",
      sub_text: "",
    },
    {
      id: 2,
      text: "You can select any one from these 3 templates",
      btn_text: "Next",
      sub_text: "",
    },
    {
      id: 3,
      text: "Click on Make it live button to make your website live",
      btn_text: "Finish",
      sub_text: "You can also view a live preview by clicking on the button",
    },
  ];
  const [templateWeb, setTemplateWeb] = React.useState({
    src: "",
    templateId: 1,
  });
  const dispatch = useDispatch();
  const answer = useSelector(
    (state: any) => state?.APIData?.saveWebsiteProfileData
  );
  const graphData = useSelector((state: any) => state?.APIData?.getCoachMark);

  const [emailValue, setEmailValue] = useState<any>();
  // console.log(partnerProfileData);
  
  useEffect(() => {
    if (
      partnerProfileData &&
      partnerProfileData.partner_domains &&
      partnerProfileData.partner_domains.length > 0
    ) {
      partnerProfileData.partner_domains.forEach((ele: any) => {
        if (ele.domain_type == 2) {
          setShowMakeItLiveBtn((keys) => ({
            ...keys,
            p2pActiveUrl: ele.domain_name,
            p2pIsActive: ele.is_active,
            p2pdomain: ele.domain_type,
          }));
        } else {
          setTemplateWeb({
            templateId: ele.template_id,
            src: "",
          });
          setShowMakeItLiveBtn((keys) => ({
            ...keys,
            p2bActiveUrl: ele.domain_name,
            p2bIsActive: ele.is_active,
            activeTemplate: ele.template_id,
            p2bdomain: ele.domain_type,
          }));
        }
      });
    }
  }, [partnerProfileData]);

  if (answer?.DomainAllotmentModal === true) {
    if (answer["DomainAllotmentModal"] === true) {
      if (!domainModalShow) {
        setWebsiteModalShow(false);
        setTimeout(() => {
          setDomainModalShow(true);
          setshowModalType({
            showDomainsModal: true,
            showWebsiteModal: false,
          });
        });
        dispatch(
          saveWebsiteData({
            WebsiteModalShow: false,
            AddWebsiteModel: false,
            DomainAllotmentModal: false,
          })
        );
      } else {
        setDomainModalShow(false);
      }
    }
  }

  const shareData = () => {
    setSppiner(true);
    const emailTest = Regex.email;
    if (!emailValue) {
      toastrService.showError("Please enter a email.");
      setSppiner(false);
      return;
    }
    if (!emailTest.test(emailValue)) {
      toastrService.showError("Please enter valid email.");
      setSppiner(false);
      return;
    }
    const body = {
      access_token: partnerProfileData && partnerProfileData["access_token"],
      domain_type:
        show && show.value_type == 1
          ? showMakeItLiveBtn.p2bdomain
          : showMakeItLiveBtn.p2pdomain,
      invite_email: emailValue,
      invite_url:
        show && show.value_type == 1
          ? showMakeItLiveBtn.p2bActiveUrl
          : showMakeItLiveBtn.p2pActiveUrl,
      partner_name:
        partnerProfileData &&
        partnerProfileData["partner_profile"] &&
        partnerProfileData["partner_profile"][0] &&
        partnerProfileData["partner_profile"][0]["partner_name"],
    };
    httpApiCall({ api: "send_web_url", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && !data.is_error) {
          console.log(data);
          show.modalShare = false;
          setShow((keys) => ({ ...keys, modalShare: false }));
          setEmailValue("");
          toastrService.showSuccess("Link shared successfully");
        } else {
          toastrService.showError(data.err || "Error occured");
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const getDomain = (email: any) => {
    const getEmail = email.target.value;
    setEmailValue(getEmail);
  };

  const updateStaet = async () => {
    const text =
      show && show.value_type == 1
        ? showMakeItLiveBtn.p2bActiveUrl
        : showMakeItLiveBtn.p2pActiveUrl;
    try {
      await navigator.clipboard?.writeText(text);
      toastrService.showSuccess("Link copy successfully");
    } catch (error) {
      console.error(error);
    }
  };

  const templateGet = (getItem: any, id: any) => {
    console.log(getItem, id);

    if (getItem) {
      setTemplateWeb(getItem);
    }
  };

  const updateTemplate = async (show: any) => {
    setUpdate(show);
    setSppiner(true);
    const body = {
      access_token: partnerProfileData && partnerProfileData.access_token,
      domainName:
        show == 1
          ? showMakeItLiveBtn.p2bActiveUrl
          : showMakeItLiveBtn.p2pActiveUrl,
      domain_type:
        show == 1 ? showMakeItLiveBtn.p2bdomain : showMakeItLiveBtn.p2pdomain,
      partner_id:
        partnerProfileData &&
        partnerProfileData["partner_profile"] &&
        partnerProfileData["partner_profile"][0] &&
        partnerProfileData["partner_profile"][0]["partner_id"],
      template_id: templateWeb ? templateWeb.templateId : "",
    };
    await httpApiCall({ api: "update_partner_template", type: "post", body })
      .then((data) => {
        setSppiner(false);
        setUpdate(0);

        if (data && !data.is_error) {
          setDomainModalShow(true);
          setshowModalType({
            showDomainsModal: true,
            showWebsiteModal: false,
          });
          // accessTokenLogin();
        } else {
          toastrService.showError(data.err || "Error occured");
          return;
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const updateHints = async () => {
    const body = {
      access_token: partnerProfileData && partnerProfileData.access_token,
    };

    await httpApiCall({ api: "updateHints", type: "post", body })
      .then((data) => {
        if (data && data.is_error == 0) {
          // setUpdateHint(false);
          dispatch(showCoachMark(false));
          accessTokenLogin();
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };
  const nextStep = (index: any) => {
    if (index) {
      flagIndex += 1;
      setFlagIndex(flagIndex);
      imageIndex += 1;
      setImageIndex(imageIndex);
    } else {
      flagIndex += 1;
      setFlagIndex(flagIndex);
      imageIndex += 1;
      setImageIndex(imageIndex);
    }
  };

  const prevStep = (index: any) => {
    if (index) {
      flagIndex -= 1;
      setFlagIndex(flagIndex);
      imageIndex -= 1;
      setImageIndex(imageIndex);
    } else {
      flagIndex -= 1;
      setFlagIndex(flagIndex);
      imageIndex -= 1;
      setImageIndex(imageIndex);
    }
  };

  const buttonLive = async (value: any) => {
    setUpdate(0);
    if (value == 1) {
      setSppiner(true);
    }
    if (value == 2) {
      setSppinerTwo(true);
    }
    if (partnerProfileData && partnerProfileData?.partner_profile?.length > 0) {
      const profileData = partnerProfileData?.partner_profile[0];
      const partnerLocalData = getStorageValue('partnerData') ? getStorageValue('partnerData')['partner_profile'] : [];

      if (
        ((profileData.bio || profileData.p2p_bio) || (partnerLocalData && partnerLocalData.length && (partnerLocalData[0]['bio'] || partnerLocalData[0]['p2p_bio']))) &&
        partnerLocalData[0].partner_image &&
        partnerLocalData[0].city_id &&
        partnerLocalData[0].zip &&
        partnerLocalData[0].partner_mobile
      ) {
        const domains = await getDomainSuggestions();
        setSppiner(false);
        setSppinerTwo(false);
        setDomainType(value == 1 ? 1 : 2);
        setTemplateId(value == 1 ? templateWeb.templateId : 4);
        setallDomains(domains);
        setWebsiteModalShow(true);
      } else {
        setSppiner(false);
        setSppinerTwo(false);
        setModalShow(true);
        setShow((keys) => ({
          ...keys,
          modalShare: false,
          value_type: value,
        }));
      }
    }
  };

  return (
    <>
      {graphData &&
        partnerProfileData &&
        partnerProfileData["partner_profile"] &&
        partnerProfileData["partner_profile"][0] &&
        partnerProfileData["partner_profile"][0]["show_domain_help"] == 1 && (
          <div
            className="coach-container text-center"
            style={{ display: !hideTooltip ? "block" : "none" }}
          >
            <div
              className="img-container-2"
              id={"suggest-card--wrapper" + flagIndex}
            >
              {/* Render images */}
              {imageWebsite.map((imageName, i) => (
                <div
                  key={i}
                  className={`hide ${imageIndex === i + 1 ? "show" : ""} ${
                    imageIndex === 6 || imageIndex === 7
                      ? "img-1-6"
                      : imageIndex === 2
                      ? "img-2"
                      : imageIndex === 4
                      ? "img-4"
                      : imageIndex === 3
                      ? "img-3"
                      : "img-1"
                  }`}
                >
                  {flagIndex == 0 && (
                    <img
                      src={imageName.srcTwo}
                      loading="lazy"
                      alt=""
                      className=""
                    />
                  )}
                  {(flagIndex == 1 || flagIndex == 2) && (
                    <div className="back_color">
                      {flagIndex == 1 && (
                        <img
                          src={imageName.srcTwo}
                          loading="lazy"
                          alt=""
                          className=""
                        />
                      )}
                      {flagIndex == 2 && (
                        <img
                          src={imageName.srcTwo}
                          loading="lazy"
                          alt=""
                          className=""
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}

              {/* Render suggestion card */}
              <div id={"suggest-card" + flagIndex} className={`suggest-card`}>
                <div className="text">
                  <p>{suggestionScreenArr[flagIndex].text}</p>
                  {suggestionScreenArr[flagIndex]?.sub_text && (
                    <span>{suggestionScreenArr[flagIndex].sub_text}</span>
                  )}
                  <div className="btn-container">
                    <img
                      src={coachmarkleft}
                      alt=""
                      onClick={() => prevStep(flagIndex)}
                      className={`${flagIndex === 0 ? "disabled" : "enabled"}`}
                    />
                    <img
                      src={coachmarkright}
                      alt=""
                      onClick={() => nextStep(flagIndex)}
                      className={`rotted ms-2 ${
                        flagIndex == 2 ? "d-none" : "enabled"
                      }`}
                    />

                    {flagIndex === 2 && (
                      <button className="btn btn-next" onClick={updateHints}>
                        Finish
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <div>
        <div className="logs">
          {showLogs && (
            <span onClick={() => setShowLogs(false)} className="text-left">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.37998 3.95312L2.33331 7.99979L6.37998 12.0465"
                  stroke="#292D32"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.6667 8H2.44666"
                  stroke="#292D32"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          )}

          <div className="logs-Tabs">
            <div></div>
            {!showLogs && (
              <div onClick={() => setShowLogs(true)} className="">
                <img src={share_icon} alt="" /> <span className="mb-0">ShareLogs</span>{" "}
              </div>
            )}
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                className="action-tab"
              >
                Action
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className="actions"
                  onClick={() => setShowUpdateModal(true)}
                >
                  Update Information
                </Dropdown.Item>
                {/* {partnerProfileData &&partnerProfileData['partner_domains']?.length > 0 && <Dropdown.Item
                  className="actions"
                  onClick={() => setShowDemoModal(true)}
                >
                  Add Demo Details
                </Dropdown.Item>
              } */}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {!showLogs && (
          <>
            <div className="website">
              <div className="row">
                <div className="col-xl-3 col-12">
                <div className="left">
                <img
                className="w-100"
                  src={
                    templateWeb.templateId == 1
                      ? imgfive
                      : templateWeb.templateId == 2
                      ? imgfour
                      : templateWeb.templateId == 3
                      ? imgsix
                      : imgfour
                  }
                  alt=""
                />
              </div>
                </div>
                <div className="col-xl-9 col-12">
                <div className="right">
                <div className="right-header">
                  <p>Partner to Business Personalized Website</p>
                </div>
                <div className="right-body">
                  <p>
                    Your personalized website is just one click away. Just
                    select any template or use the default template and click on
                    the button to make your website live. It’s that SIMPLE!
                  </p>
                </div>
                <div className="website-box">
                  {imageWebsite &&
                    imageWebsite.map((item: any, i: any) => (
                      <div
                        key={i}
                        className={
                          templateWeb &&
                          (templateWeb.templateId == i + 1 ||
                            showMakeItLiveBtn.activeTemplate == i + 1)
                            ? "selected"
                            : ""
                        }
                        onClick={() => templateGet(item, i)}
                      >
                        <img
                         id="templates"
                          src={item.src}
                          alt="img"
                          className={
                            showMakeItLiveBtn.activeTemplate ==
                              item.templateId ||
                            templateWeb.templateId === item.templateId
                              ? "show"
                              : ""
                          }
                        />
                        {showMakeItLiveBtn.activeTemplate ==
                          item.templateId && (
                          <span className="live__badge">Live</span>
                        )}
                      </div>
                    ))}
                </div>
                <div className="website-live">
                  {showMakeItLiveBtn.p2bIsActive == 0 &&
                  showMakeItLiveBtn.p2bActiveUrl == "" ? (
                    <div className="d-flex  flex-column w-100 d-lg-block flex-lg-block  ">
                      <button
                      id="button-live"
                        disabled={sppiner}
                        onClick={() => buttonLive(1)}
                        className="btn-button"
                      >
                        <span className="me-2">
                          <img src={global} alt="" />
                        </span>
                        Make it Live
                        <span className="ms-2">
                          <img src={whiteArrow} alt="" />
                        </span>
                        {sppiner && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                      <button className="btn-button ms-lg-3 bg-white prview">
                        <Link
                        id="temp-link"
                          target="_blank"
                          to={`http://template${templateWeb.templateId}.credee.net/`}
                        >
                          Live Preview{" "}
                        </Link>
                        <span className="ms-2">
                          <img src={Eye} alt="" />
                        </span>
                      </button>
                    </div>
                  ) : (
                    <>
                      {showMakeItLiveBtn.activeTemplate ==
                        templateWeb.templateId && (
                        <div className="domain_availabel">
                          <img src={sendlivedata} alt="" />
                          <span>{showMakeItLiveBtn.p2bActiveUrl}</span>
                          <img
                          id="liveSend"
                            src={makelivesend}
                            alt=""
                            onClick={() =>
                              setShow((keys) => ({
                                ...keys,
                                modalShare: true,
                                value_type: 1,
                              }))
                            }
                          />
                        </div>
                      )}
                      {templateWeb.templateId !=
                        showMakeItLiveBtn.activeTemplate && (
                        <div className="d-flex  flex-column w-100 d-lg-block flex-lg-block">
                          <button
                          id="updateTemp"
                            className="btn-button"
                            onClick={() => {
                              updateTemplate(1);
                            }}
                          >
                            <span className="me-2">
                              <img src={global} alt="" />
                            </span>
                            Update Theme
                            <span className="ms-2">
                              <img src={whiteArrow} alt="" />
                            </span>
                            
                            {sppiner && update == 1 && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}
                          </button>
                          <button className="btn-button ms-lg-3 bg-white prview">
                            <Link
                            id="previewTemplate"
                              target="_blank"
                              to={`http://template${templateWeb.templateId}.credee.net/`}
                            >
                              Preview Template
                            </Link>
                            <span className="ms-2">
                              <img src={Eye} alt="" />
                            </span>
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
                  </div>
              </div>
             
            
            </div>
            <div className="website mt-4">
              <div className="row">
            <div className="col-xl-3 col-12">
            <div className="left">
                <img src={imgseven} alt=""    className="w-100" />
              </div>
              </div>
            <div className="col-xl-9 col-12">
                 <div className="right">
                <div className="right-header">
                  <p>Partner to Partner Personalized Website</p>
                </div>
                <div className="right-body">
                  <p>
                    Partner to Partner website is a specialized tool crafted to
                    help you expand your network by connecting with potential
                    sub-partners. This will help in:
                  </p>
                  <ul>
                    <li>
                      <span className="me-2">
                        <img src={greenTick} alt="" />
                      </span>
                      <span className="partner_growth">Network Growth: </span>
                      Growing a collaborative and lucrative partner network
                    </li>
                    <li>
                      <span className="me-2">
                        <img src={greenTick} alt="" />
                      </span>
                      <span className="partner_growth">
                        Efficient Recruitment:{" "}
                      </span>
                      Utilize your site to educate and recruit sub-partners
                    </li>
                    <li>
                      <span className="me-2">
                        <img src={greenTick} alt="" />
                      </span>
                      <span className="partner_growth">Shared Resources: </span>
                      Access and provide a wealth of resources to support your
                      sub-partners
                    </li>
                    {/* <li>
                  <span className="me-2">
                    <img src={greenTick} alt="" />
                  </span>
                  Neque porro quisquam est qui dolorem
                </li> */}
                  </ul>
                </div>
                <div className="website-live">
                  {showMakeItLiveBtn.p2pIsActive == 0 &&
                  showMakeItLiveBtn.p2pActiveUrl == "" ? (
                    <div className="d-flex  flex-column w-100 d-lg-block flex-lg-block">
                      <button
                      id="button_live2"
                        onClick={() => buttonLive(2)}
                        className="btn-button"
                      >
                        <span className="me-2">
                          <img src={global} alt="" />
                        </span>
                        Make it Live
                        <span className="ms-2">
                          <img src={whiteArrow} alt="" />
                        </span>
                        {sppinerTwo && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                      <button className="btn-button ms-lg-3 bg-white prview">
                        <Link
                        id="temp=-live"
                          target="_blank"
                          to={"http://template4.credee.net/"}
                        >
                          {" "}
                          Live Preview{" "}
                        </Link>
                        <span className="ms-2">
                          <img src={Eye} alt="" />
                        </span>
                      </button>
                    </div>
                  ) : (
                    <div className="domain_availabel">
                      <img src={sendlivedata} alt="" />
                      <span>{showMakeItLiveBtn.p2pActiveUrl}</span>
                      <img
                        src={makelivesend}
                        alt=""
                        id="liveSend2"
                        onClick={() =>
                          setShow((keys) => ({
                            ...keys,
                            modalShare: true,
                            value_type: 2,
                          }))
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              </div>
              </div>

           
           
            </div>
          </>
        )}
        {showLogs && <Logs />}
        {partnerProfileData &&
        partnerProfileData.partner_profile &&
        partnerProfileData.partner_profile[0] &&
        (partnerProfileData.partner_profile[0].bio ||
          partnerProfileData.partner_profile[0].p2p_bio) &&
        partnerProfileData.partner_profile[0].city_id &&
        partnerProfileData.partner_profile[0].zip &&
        partnerProfileData.partner_profile[0].partner_image &&
        partnerProfileData.partner_profile[0].partner_mobile ? (
          <>
            {showModalType.showDomainsModal ? (
              <DomainAllotmentModal
                show={domainModalShow}
                onHide={() => {
                  accessTokenLogin();
                  setDomainModalShow(false);
                }}
              />
            ) : (
              allDomains &&
              allDomains.length > 0 && (
                <WebsiteLiveModal
                  show={websiteModalShow}
                  onHide={() => {
                    setWebsiteModalShow(false);
                  }}
                  alldomains={allDomains}
                  domain_type={domainType}
                  template_id={templateId}
                />
              )
            )}
          </>
        ) : (
          <AddWebsiteModel
            show={modalShow}
            onHide={() => setModalShow(false)}
            domain_type={show.value_type}
            showDomailModal={() => buttonLive(show.value_type)}
            template_id={show.value_type == 1 ? templateWeb.templateId : 4}
          />
        )}
      </div>
      <div>
        <Modal
          show={show.modalShare}
          onHide={() => setShow((keys) => ({ ...keys, modalShare: false }))}
          animation={false}
          className="share_journey"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="share">
              <img src={referral} alt="" />
              <p>Share with people and start your earning journey</p>
            </div>
            <div className="domain_availabel modal_domain">
              <img src={sendlivedata} alt="" />
              <span>
                {show && show.value_type == 1
                  ? showMakeItLiveBtn.p2bActiveUrl
                  : showMakeItLiveBtn.p2pActiveUrl}
              </span>
              <img id="copystate" src={copy} alt="" onClick={updateStaet} />
            </div>
            <p className="or">or</p>
            <div className="email_enter">
              <label>
                <span>Email</span>
                <input
                id="shareEmail"
                  type="email"
                  name="share_email"
                  placeholder="Enter email address of recipient"
                  className="form-control"
                  onChange={(e) => getDomain(e)}
                />
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer className="share_footer">
            <Button
            id="shareData"
              variant="primary"
              onClick={shareData}
              disabled={!emailValue}
              className={!emailValue ? "" : ""}
            >
              Share <img src={whiteArrow} alt="" />{" "}
              {sppiner && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showUpdateModal && (
        <AddWebsiteModel
          show={showUpdateModal}
          showDomailModal={console.log('from website called')}
          onHide={() => setShowUpdateModal(false)}
        />
      )}
      {showDemoModal && (
        <AddDemoModal
          show={showDemoModal}
          onHide={() => setShowDemoModal(false)}
          data ={eventData}
        />
      )}
    </>
  );
};
export default Website;
